import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized.js";
import _get from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/get.js";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/dropdown/button/dropdownbuttonview
 */

import ButtonView from "../../button/buttonview";
import dropdownArrowIcon from "../../../theme/icons/dropdown-arrow.svg";
import IconView from "../../icon/iconview";

/**
 * The default dropdown button view class.
 *
 *		const view = new DropdownButtonView();
 *
 *		view.set( {
 *			label: 'A button',
 *			keystroke: 'Ctrl+B',
 *			tooltip: true
 *		} );
 *
 *		view.render();
 *
 *		document.body.append( view.element );
 *
 * Also see the {@link module:ui/dropdown/utils~createDropdown `createDropdown()` util}.
 *
 * @implements module:ui/dropdown/button/dropdownbutton~DropdownButton
 * @extends module:ui/button/buttonview~ButtonView
 */
var DropdownButtonView = /*#__PURE__*/function (_ButtonView) {
  _inherits(DropdownButtonView, _ButtonView);
  var _super = _createSuper(DropdownButtonView);
  /**
   * @inheritDoc
   */
  function DropdownButtonView(locale) {
    var _this;
    _classCallCheck(this, DropdownButtonView);
    _this = _super.call(this, locale);

    /**
     * An icon that displays arrow to indicate a dropdown button.
     *
     * @readonly
     * @member {module:ui/icon/iconview~IconView}
     */
    _this.arrowView = _this._createArrowView();
    _this.extendTemplate({
      attributes: {
        'aria-haspopup': true
      }
    });

    // The DropdownButton interface expects the open event upon which will open the dropdown.
    _this.delegate('execute').to(_assertThisInitialized(_this), 'open');
    return _this;
  }

  /**
   * @inheritDoc
   */
  _createClass(DropdownButtonView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(DropdownButtonView.prototype), "render", this).call(this);
      this.children.add(this.arrowView);
    }

    /**
     * Creates a {@link module:ui/icon/iconview~IconView} instance as {@link #arrowView}.
     *
     * @private
     * @returns {module:ui/icon/iconview~IconView}
     */
  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var arrowView = new IconView();
      arrowView.content = dropdownArrowIcon;
      arrowView.extendTemplate({
        attributes: {
          class: 'ck-dropdown__arrow'
        }
      });
      return arrowView;
    }
  }]);
  return DropdownButtonView;
}(ButtonView);
export { DropdownButtonView as default };